import React from "react";
import { Divider, Paper, Typography, Stack, Box } from "@mui/material";
import Molecule from "../../../MComponent/Molecule";
import TeamPlanTable from "./TeamPlanTable";

const { Tabs } = Molecule;

const MyTeamPlan = () => {
  const tabList = [
    {
      label: "Appraiser",
      Component: TeamPlanTable,
      props: {
        relationshipType: "LR",
        role: "A",
      },
    },
    {
      label: "Reviewer",
      Component: TeamPlanTable,
      props: {
        relationshipType: "FR",
        role: "R",
      },
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <Stack rowGap={"1rem"} sx={{ width: "80em", margin: "0 auto" }}>
        <Typography variant="h4">My Team Plan</Typography>
        <Divider />
        <Paper>
          <Tabs componentList={tabList} />
        </Paper>
      </Stack>
    </Box>
  );
};

export default MyTeamPlan;
